// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"856":"3152d13b","950":"071090c2"}[chunkId] + ".js";
};